import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {GridComponent, GridDataResult, SelectableSettings, SortSettings} from "@progress/kendo-angular-grid";
import {orderBy, SortDescriptor} from "@progress/kendo-data-query";
import {SettingsEventActionService} from "./settings-eventaction.service";
import {DtoEventAction} from "../../shared/models/DtoEventAction";
import {ActionType} from "../../shared/enums/actionType";
import {EventActionComponent} from "./eventaction.component";
import {DialogService} from "@progress/kendo-angular-dialog";
import {DtoDeleteResult} from "../../shared/models/DtoDeleteResult";
import {SharedService} from "../../shared/shared.service";

@Component({
    selector: 'app-settings-eventaction-color',
    template: require('./settings-eventaction-color.component.html'),
    styles: [require('./settings-eventaction-color.component.css')]
})

@AutoUnsubscribe()
export class SettingsEventActionColorComponent implements OnInit {
    @ViewChild('gridProducts', {static: false}) gridProducts: GridComponent;
    @ViewChild('gridOxidations', {static: false}) gridOxidations: GridComponent;
    @ViewChild('gridTreatments', {static: false}) gridTreatments: GridComponent;

    phbConfig: PageHeaderBarConfig;
    selectableSettings: SelectableSettings = {
        checkboxOnly: false,
        enabled: true,
        mode: "single"
    };
    sortableSettings: SortSettings = {
        mode: 'single',
        allowUnsort: false
    };

    selectedProductIds: number[] = [];
    productGridSort: SortDescriptor[] = [];
    productGridView: GridDataResult;
    productData: DtoEventAction[];

    selectedOxidationIds: number[] = [];
    oxidationGridSort: SortDescriptor[] = [];
    oxidationGridView: GridDataResult;
    oxidationData: DtoEventAction[];

    selectedTreatmentIds: number[] = [];
    treatmentGridSort: SortDescriptor[] = [];
    treatmentGridView: GridDataResult;
    treatmentData: DtoEventAction[];

    constructor(private breadcrumService: BreadcrumService,
                private ds: SettingsEventActionService,
                private dialogService: DialogService,
                private ss: SharedService) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'instellingen', isLastStep: false },
            { text: 'kleurkaart instellingen', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
        this.phbConfig = {
            title: '',
            buttonDefinition: [
                {
                    description: 'TOEVOEGEN',
                    clickEventType: 'create',
                    isSmall: false
                },
                {
                    description: 'WIJZIGEN',
                    clickEventType: 'edit',
                    isSmall: false
                },
                {
                    description: 'VERWIJDEREN',
                    clickEventType: 'delete',
                    isSmall: false
                }
            ]
        };
    }

    ngAfterViewInit() {
        this.loadProducts(false);
    }

    tabSelected(e) {
        if (e.index == 0) {
            this.loadProducts(false);
        } else if (e.index == 1) {
            this.loadOxidations(false);
        } else if (e.index == 2) {
            this.loadTreatments(false);
        }
    }

    showEventActionEditWindow(id: number, typeId: number, header: string, subheader: string) {
        const dialogRef = this.dialogService.open({
            content: EventActionComponent
        });

        const dialogContent: EventActionComponent = dialogRef.content.instance;
        dialogContent.dialog = dialogRef;
        dialogContent.id = id;
        dialogContent.typeId = typeId;
        dialogContent.header = header;
        dialogContent.subheader = subheader;

        dialogRef.result
            .subscribe((result: boolean) => {
                if (result) {
                    if (typeId == ActionType.COLORPRODUCT)
                        this.loadProducts(true);
                    else if (typeId == ActionType.OXIDATION)
                        this.loadOxidations(true);
                    else if (typeId == ActionType.COLORTREATMENT)
                        this.loadTreatments(true);
                }
            });
    }

    getSelectedId(type: number): number {
        if (type == ActionType.COLORPRODUCT) {
            if (this.selectedProductIds.length == 1) {
                return this.selectedProductIds[0];
            }
            return 0;
        } else if (type == ActionType.OXIDATION) {
            if (this.selectedOxidationIds.length == 1) {
                return this.selectedOxidationIds[0];
            }
            return 0;
        } else if (type == ActionType.COLORTREATMENT) {
            if (this.selectedTreatmentIds.length == 1) {
                return this.selectedTreatmentIds[0];
            }
            return 0;
        }

        return 0;
    }

    // PRODUCT
    loadProducts(reload: boolean) {
        if (reload || !this.productData) {
            this.ds.getEventActionsForTypes([ActionType.COLORPRODUCT]).subscribe((res: DtoEventAction[]) => {
                this.productData = res;
                this.selectedProductIds = [];
                this.showProducts();
            });
        }
    }

    productGridSortChange(sort: SortDescriptor[]): void {
        this.productGridSort = sort;
        this.showProducts();
    }

    showProducts() {
        this.productGridView = {
            data: orderBy(this.productData, this.productGridSort),
            total: this.productData.length
        };
    }

    phbProductBtnClicked(event) {
        if (event == 'create') {
            this.showEventActionEditWindow(0, ActionType.COLORPRODUCT, 'KLEURKAART', 'PRODUCT');
        } else if (event == 'edit') {
            if (this.getSelectedId(ActionType.COLORPRODUCT) > 0) {
                this.showEventActionEditWindow(this.getSelectedId(ActionType.COLORPRODUCT), ActionType.COLORPRODUCT, 'KLEURKAART', 'PRODUCT');
            }
        } else if (event == 'delete') {
            if (this.getSelectedId(ActionType.COLORPRODUCT) > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEventActionById(this.getSelectedId(ActionType.COLORPRODUCT))
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadProducts(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridProductRowdoubleClicked(event) {
        if (this.getSelectedId(ActionType.COLORPRODUCT) > 0) {
            this.showEventActionEditWindow(this.getSelectedId(ActionType.COLORPRODUCT), ActionType.COLORPRODUCT, 'KLEURKAART', 'PRODUCT');
        }
    }

    // OXIDATION
    loadOxidations(reload: boolean) {
        if (reload || !this.oxidationData) {
            this.ds.getEventActionsForTypes([ActionType.OXIDATION]).subscribe((res: DtoEventAction[]) => {
                this.oxidationData = res;
                this.selectedOxidationIds = [];
                this.showOxidations();
            });
        }
    }

    oxidationGridSortChange(sort: SortDescriptor[]): void {
        this.oxidationGridSort = sort;
        this.showOxidations();
    }

    showOxidations() {
        this.oxidationGridView = {
            data: orderBy(this.oxidationData, this.oxidationGridSort),
            total: this.oxidationData.length
        };
    }

    phbOxidationBtnClicked(event) {
        if (event == 'create') {
            this.showEventActionEditWindow(0, ActionType.OXIDATION, 'KLEURKAART', 'OXIDATIE');
        } else if (event == 'edit') {
            if (this.getSelectedId(ActionType.OXIDATION) > 0) {
                this.showEventActionEditWindow(this.getSelectedId(ActionType.OXIDATION), ActionType.OXIDATION, 'KLEURKAART', 'OXIDATIE');
            }
        } else if (event == 'delete') {
            if (this.getSelectedId(ActionType.OXIDATION) > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEventActionById(this.getSelectedId(ActionType.OXIDATION))
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadOxidations(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridOxidationRowdoubleClicked(event) {
        if (this.getSelectedId(ActionType.OXIDATION) > 0) {
            this.showEventActionEditWindow(this.getSelectedId(ActionType.OXIDATION), ActionType.OXIDATION, 'KLEURKAART', 'OXIDATIE');
        }
    }

    // TREATMENT
    loadTreatments(reload: boolean) {
        if (reload || !this.treatmentData) {
            this.ds.getEventActionsForTypes([ActionType.COLORTREATMENT]).subscribe((res: DtoEventAction[]) => {
                this.treatmentData = res;
                this.selectedTreatmentIds = [];
                this.showTreatments();
            });
        }
    }

    treatmentGridSortChange(sort: SortDescriptor[]): void {
        this.treatmentGridSort = sort;
        this.showTreatments();
    }

    showTreatments() {
        this.treatmentGridView = {
            data: orderBy(this.treatmentData, this.treatmentGridSort),
            total: this.treatmentData.length
        };
    }

    phbTreatmentBtnClicked(event) {
        if (event == 'create') {
            this.showEventActionEditWindow(0, ActionType.COLORTREATMENT, 'KLEURKAART', 'VOOR/NABEHANDELING');
        } else if (event == 'edit') {
            if (this.getSelectedId(ActionType.COLORTREATMENT) > 0) {
                this.showEventActionEditWindow(this.getSelectedId(ActionType.COLORTREATMENT), ActionType.COLORTREATMENT, 'KLEURKAART', 'VOOR/NABEHANDELING');
            }
        } else if (event == 'delete') {
            if (this.getSelectedId(ActionType.COLORTREATMENT) > 0) {
                this.ss.confirm('Weet u zeker dat u dit record wilt verwijderen?')
                    .subscribe((res: boolean) => {
                        if (res) {
                            this.ds.deleteEventActionById(this.getSelectedId(ActionType.COLORTREATMENT))
                                .subscribe((delRes: DtoDeleteResult) => {
                                    if (delRes.isDeleted) {
                                        this.loadTreatments(true);
                                    } else {
                                        this.ss.message(delRes.infoMessage);
                                    }
                                });
                        }
                    });
            }
        }
    }

    gridTreatmentRowdoubleClicked(event) {
        if (this.getSelectedId(ActionType.COLORTREATMENT) > 0) {
            this.showEventActionEditWindow(this.getSelectedId(ActionType.COLORTREATMENT), ActionType.COLORTREATMENT, 'KLEURKAART', 'VOOR/NABEHANDELING');
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-eventaction/settings-eventaction-color.component.ts